export default __webpack_public_path__ + "static/media/devices.063658fa.svg";